interface CommunityMapValue {
  id: string;
  value: string;
}

interface CommunityEntry {
  id: string;
  value: string;
  text: string;
}

export const communityMap: Record<string, CommunityMapValue> = {
  AN: { id: 'AN', value: '01' }, // Andalucía itself
  AL: { id: 'AN', value: '01' }, // Almería, parent region: Andalucía
  CA: { id: 'AN', value: '01' }, // Cádiz, parent region: Andalucía
  CO: { id: 'AN', value: '01' }, // Córdoba, parent region: Andalucía
  GR: { id: 'AN', value: '01' }, // Granada, parent region: Andalucía
  H: { id: 'AN', value: '01' }, // Huelva, parent region: Andalucía
  J: { id: 'AN', value: '01' }, // Jaén, parent region: Andalucía
  MA: { id: 'AN', value: '01' }, // Málaga, parent region: Andalucía
  SE: { id: 'AN', value: '01' }, // Sevilla, parent region: Andalucía
  AR: { id: 'AR', value: '02' }, // Aragón itself
  HU: { id: 'AR', value: '02' }, // Huesca, parent region: Aragón
  TE: { id: 'AR', value: '02' }, // Teruel, parent region: Aragón
  Z: { id: 'AR', value: '02' }, // Zaragoza, parent region: Aragón
  AS: { id: 'AS', value: '03' }, // Asturias itself
  O: { id: 'AS', value: '03' }, // Asturias, parent region: Asturias
  CB: { id: 'CB', value: '05' }, // Cantabria itself
  S: { id: 'CB', value: '05' }, // Cantabria, parent region: Cantabria
  CL: { id: 'CL', value: '07' }, // Castilla y León itself
  AV: { id: 'CL', value: '07' }, // Ávila, parent region: Castilla y León
  BU: { id: 'CL', value: '07' }, // Burgos, parent region: Castilla y León
  P: { id: 'CL', value: '07' }, // Palencia, parent region: Castilla y León
  LE: { id: 'CL', value: '07' }, // León, parent region: Castilla y León
  SO: { id: 'CL', value: '07' }, // Soria, parent region: Castilla y León
  SA: { id: 'CL', value: '07' }, // Salamanca, parent region: Castilla y León
  SG: { id: 'CL', value: '07' }, // Segovia, parent region: Castilla y León
  VA: { id: 'CL', value: '07' }, // Valladolid, parent region: Castilla y León
  ZA: { id: 'CL', value: '07' }, // Zamora, parent region: Castilla y León
  CM: { id: 'CM', value: '06' }, // Castilla-La Mancha itself
  GU: { id: 'CM', value: '06' }, // Guadalajara, parent region: Castilla-La Mancha
  CR: { id: 'CM', value: '06' }, // Ciudad Real, parent region: Castilla-La Mancha
  CU: { id: 'CM', value: '06' }, // Cuenca, parent region: Castilla-La Mancha
  AB: { id: 'CM', value: '06' }, // Albacete, parent region: Castilla-La Mancha
  TO: { id: 'CM', value: '06' }, // Toledo, parent region: Castilla-La Mancha
  CN: { id: 'CN', value: '04' }, // Islas Canarias itself
  GC: { id: 'CN', value: '04' }, // Las Palmas, parent region: Islas Canarias
  TF: { id: 'CN', value: '04' }, // Santa Cruz de Tenerife, parent region: Islas Canarias
  CT: { id: 'CT', value: '08' }, // Cataluña itself
  GI: { id: 'CT', value: '08' }, // Gerona, parent region: Cataluña
  B: { id: 'CT', value: '08' }, // Barcelona, parent region: Cataluña
  L: { id: 'CT', value: '08' }, // Lérida, parent region: Cataluña
  T: { id: 'CT', value: '08' }, // Tarragona, parent region: Cataluña
  EX: { id: 'EX', value: '09' }, // Extremadura itself
  BA: { id: 'EX', value: '09' }, // Badajoz, parent region: Extremadura
  CC: { id: 'EX', value: '09' }, // Cáceres, parent region: Extremadura
  GA: { id: 'GA', value: '10' }, // Galicia itself
  C: { id: 'GA', value: '10' }, // La Coruña, parent region: Galicia
  PO: { id: 'GA', value: '10' }, // Pontevedra, parent region: Galicia
  OR: { id: 'GA', value: '10' }, // Orense, parent region: Galicia
  LU: { id: 'GA', value: '10' }, // Lugo, parent region: Galicia
  IB: { id: 'IB', value: '11' }, // Islas Baleares itself
  PM: { id: 'IB', value: '11' }, // Baleares, parent region: Islas Baleares
  MC: { id: 'MC', value: '14' }, // Murcia itself
  MU: { id: 'MC', value: '14' }, // Murcia, parent region: Murcia
  MD: { id: 'MD', value: '13' }, // Madrid itself
  M: { id: 'MD', value: '13' }, // Madrid, parent region: Madrid
  NC: { id: 'NC', value: '16' }, // Navarra itself
  NA: { id: 'NC', value: '16' }, // Navarra, parent region: Navarra
  PV: { id: 'PV', value: '17' }, // País Vasco itself
  SS: { id: 'PV', value: '17' }, // Guipúzcoa, parent region: País Vasco
  VI: { id: 'PV', value: '17' }, // Álava, parent region: País Vasco
  BI: { id: 'PV', value: '17' }, // Vizcaya, parent region: País Vasco
  RI: { id: 'RI', value: '12' }, // La Rioja itself
  LO: { id: 'RI', value: '12' }, // La Rioja, parent region: La Rioja
  VC: { id: 'VC', value: '15' }, // Comunidad Valenciana itself
  CS: { id: 'VC', value: '15' }, // Castellón, parent region: Comunidad Valenciana
  A: { id: 'VC', value: '15' }, // Alicante, parent region: Comunidad Valenciana
  V: { id: 'VC', value: '15' }, // Valencia, parent region: Comunidad Valenciana
  CE: { id: 'CE', value: '20' }, // Ceuta itself
  ML: { id: 'ML', value: '21' } // Melilla itself
};

export const communityList: Record<string, CommunityEntry[]> = {
  es: [
    { id: 'AN', value: '01', text: 'Andalucía' },
    { id: 'AR', value: '02', text: 'Aragón' },
    { id: 'AS', value: '03', text: 'Asturias' },
    { id: 'CN', value: '04', text: 'Islas Canarias' },
    { id: 'CB', value: '05', text: 'Cantabria' },
    { id: 'CM', value: '06', text: 'Castilla-La Mancha' },
    { id: 'CL', value: '07', text: 'Castilla y León' },
    { id: 'CT', value: '08', text: 'Cataluña' },
    { id: 'EX', value: '09', text: 'Extremadura' },
    { id: 'GA', value: '10', text: 'Galicia' },
    { id: 'IB', value: '11', text: 'Islas Baleares' },
    { id: 'RI', value: '12', text: 'La Rioja' },
    { id: 'MD', value: '13', text: 'Madrid' },
    { id: 'MC', value: '14', text: 'Murcia' },
    { id: 'VC', value: '15', text: 'València' },
    { id: 'NC', value: '16', text: 'Navarra' },
    { id: 'PV', value: '17', text: 'País Vasco' },
    { id: 'CE', value: '20', text: 'Ceuta' },
    { id: 'ML', value: '21', text: 'Melilla' },
    { id: '', value: '22', text: 'Estado (en el extranjero)' }
  ],
  en: [
    { id: 'AN', value: '01', text: 'Andalusia' },
    { id: 'AR', value: '02', text: 'Aragon' },
    { id: 'AS', value: '03', text: 'Asturias' },
    { id: 'CN', value: '04', text: 'Canary Islands' },
    { id: 'CB', value: '05', text: 'Cantabria' },
    { id: 'CM', value: '06', text: 'Castile-La Mancha' },
    { id: 'CL', value: '07', text: 'Castile and León' },
    { id: 'CT', value: '08', text: 'Catalonia' },
    { id: 'EX', value: '09', text: 'Extremadura' },
    { id: 'GA', value: '10', text: 'Galicia' },
    { id: 'IB', value: '11', text: 'Balearic Islands' },
    { id: 'RI', value: '12', text: 'La Rioja' },
    { id: 'MD', value: '13', text: 'Madrid' },
    { id: 'MC', value: '14', text: 'Murcia' },
    { id: 'VC', value: '15', text: 'Valencia' },
    { id: 'NC', value: '16', text: 'Navarre' },
    { id: 'PV', value: '17', text: 'Basque Country' },
    { id: 'CE', value: '20', text: 'Ceuta' },
    { id: 'ML', value: '21', text: 'Melilla' },
    { id: '', value: '22', text: 'State (abroad)' }
  ]
};
